import React from 'react';

interface State { hasError: boolean; error: Error | null; }

export default class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: any) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center">
          <div className="bg-white p-8 rounded shadow-lg max-w-2xl">
            <h1 className="text-xl font-bold mb-2">Application Error</h1>
            <p className="text-sm text-slate-600 mb-4">An unexpected error occurred in the application.</p>
            <pre className="text-xs bg-slate-100 p-3 rounded text-rose-700 overflow-auto">
              {this.state.error?.message}
            </pre>
            <p className="mt-4 text-xs text-slate-500">Check browser console for a full stack trace.</p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
